module.exports = __webpack_public_path__ + "static/media/zeder_contact.54fe7e62.png";